export const LevelData = [
    {
        level: 'Level K',
        range: '适合启蒙',
        target: ['单元主题：16个', '学习用语：40 +', '重点词汇：111个', '生活场景：25个', '重点句型：33个', '个性化辅导学习: 16节'],
        target_2: [{
            num: '111<span>个</span>',
            content: '重点词汇',
        }, {
            num: '33<span>个</span>',
            content: '重点句型',
        }, {
            num: '40<span>+</span>',
            content: '学习用语',
        }],
        targetDetail: [
            '在全英文讲授环境中，能借助多媒体、实物教具和身体语言理解教学内容，听懂简单的学习用语，聚焦常见词汇和单句的练习。',
            '感知英语的发音特点，为英语发音练习打下基础。',
            '学完Level K可为进入小学做好充分准备。',
        ],
        title_background_color: '#FFC41D',
    },
    {
        level: 'Level 1',
        range: '适合1-3年级',
        target: ['单元主题：16个', '英文字母：26个', '重点词汇：286个', '自然拼读：30 +', '重点句型：148个', '手工项目：16个',],
        target_2: [{
            num: '286<span>个</span>',
            content: '重点词汇',
        }, {
            num: '148<span>个</span>',
            content: '重点句型',
        }, {
            num: '30<span>+</span>',
            content: '自然拼读',
        }],
        targetDetail: [
            '认读和书写字母，掌握26个英文字母及字母音，学习简单的CVC单词等自然拼读知识，初步学习自然拼读规则。',
            '进一步在纯英文环境中进行听说训练，能进行简单的日常对话。',
            '学完Level 1可达到小学二至三年级水平。',
        ],
        title_background_color: '#FFAE29',
    },
    {
        level: 'Level 2',
        range: '适合3-4年级',
        target: ['单元主题：16个', '重点语法：26个', '重点词汇：449个', '重点句型：256个', '阅读&演讲：32 +'],
        target_2: [{
            num: '449<span>个</span>',
            content: '重点词汇',
        }, {
            num: '256<span>个</span>',
            content: '重点句型',
        }, {
            num: '32<span>+</span>',
            content: '自然拼读',
        }],
        targetDetail: [
            '进一步学习自然拼读规则，开始学习阅读策略和方法。',
            '掌握基础语法规则；能就日常话题进行沟通。',
            '学完Level 2可达到入小学四至五年级水平。',
        ],
        title_background_color: '#FF8D34',
    },
    {
        level: 'Level 3',
        range: '适合5-6年级',
        target: ['单元主题：16个', '重点语法：40 +', '重点词汇：403个', '主题阅读：16个', '重点句型：239个', '主题演讲：16个'],
        target_2: [{
            num: '403<span>个</span>',
            content: '重点词汇',
        }, {
            num: '239<span>个</span>',
            content: '重点句型',
        }, {
            num: '40<span>+</span>',
            content: '自然拼读',
        }],
        targetDetail: [
            '学习常用词汇、句型和语法，提升沟通的能力；能在图片的辅助下读懂150词左右的文章。',
            '能用英文写出50词左右的小短文，通过主题阅读学习初步掌握常见的自然拼读规则。',
            '学完Level 3可达到小学毕业优秀水平。',
        ],
        title_background_color: '#FF7D17',
    },
    {
        level: 'Level 4',
        range: '适合6-7年级',
        target: ['重点词汇：约341个', '单元主题：16个', '关键句型：395个', '主题阅读：16个', '重点语法：40 +', '主题演讲：16个'],
        target_2: [{
            num: '341<span>个</span>',
            content: '重点词汇',
        }, {
            num: '395<span>个</span>',
            content: '重点句型',
        }, {
            num: '40<span>+</span>',
            content: '自然拼读',
        }],
        targetDetail: [
            '基本掌握常见的自然拼读规则，能应对多种日常话题，并能开展抽象话题的讨论。',
            '能在图片的辅助下读懂150–200词的文章，能写出50–100词的短文，达到初中一年级英语水平。',
            '学好Level 4能为小升初做好准备。',
        ]
        ,
        title_background_color: '#FF6A17',
    }
];

export const KETLevelData = [
    {
        level: 'Module 1',
        range: '真题通关',
        target: ['<span>4 个</span>单元主题  <span>28 个</span>重点语法', '<span>34 组</span>Listening题型讲解', '<span>7 节</span>Reading and Writing题型讲解'],
        targetDetail: [
            '熟练掌握KET考试所有题型',
            '掌握每种题型的解题步骤，有效提升考试技巧',
            '通过真题检测学习成果',
        ],
        title_background_color: '#F5C54A',
    },
    {
        level: 'Module 2',
        range: '精讲精练',
        target: ['<span>56 个</span>听、说、读、写强化模块', '<span>14 个</span>语音知识  <span>34 组</span>主题词汇', '<span>28 个</span>重点语法'],
        targetDetail: [
            '全面提升听、说能力，能听懂和各类日常话题相关的对话及独白',
            '熟悉和巩固KET考试所需的语音知识、主题词汇和重点语法',
            '学好KET精讲精练达到CEFR的A2水平',
        ],
        title_background_color: '#F1B04A',
    },
    {
        level: 'Module 3',
        range: '必考语法',
        target: ['<span>14 个</span>单元主题', '<span>56 个</span>语法知识', '<span>12 类</span>核心语法考点'],
        targetDetail: [
            '全面掌握KET考试的12类56个核心语法知识',
            '通过真题，练习和检测KET考试中语法知识的掌握情况',
            '学好KET必考语法可以掌握小学及初中阶段全部语法知识',
        ],
        title_background_color: '#EB9049',
    }
]



// WEBPACK FOOTER //
// ./src/lib/components/LessonPath/static/json/level-data.js